<template>
  <div @click.stop="">
    <div class="content">
      <ul>
        <li>冀ICP备18034370号-1</li>
        <li>霏凡伟业房地产开发有限公司 Ⓒ 版权所有</li>
        <li @click="()=>{isLaw=true;isSupport=false}">法律声明</li>
        <li @click="()=>{isSupport=true;isLaw=false}">网站支持</li>
      </ul>
    </div>
    <div class="law" :class="{wLaw : isLaw}">
      <ul>
        <li v-for="(item,index) in legalList" :key="index">
          <h3>{{item.title}}</h3>
          <p>{{item.content}}</p>
        </li>
        <li @click="isLaw=false">
          <img src="../../static/img/back.png" alt="">
        </li>
      </ul>
    </div>

    <div class="support" :class="{ wSupport : isSupport}">
      <div>
        <h2>Site Map</h2>
        <p>网站支持</p>
        <ul>
          <li v-for="(item,index) in navList" :key="index" @click="navChange('nav',item.toLink)">
            <span :class="{active : navActive==item.toLink}">{{item.name}}</span>
            <ol v-if="item.navChildList && index+1!=navList.length">
              <li v-for="(itm,idx) in item.navChildList" :key="idx" @click="navChange('navChild',item.toLink,itm.toLink)" :class="{activeChild : navChildActive==itm.toLink}">
                {{itm.name}}
                <i></i>
              </li>
            </ol>
          </li>
          <li @click="goTopSearch">站内搜索</li>
          <li @click="()=>{isSupport=false;isLaw=true}">法律声明</li>
          <li @click="isSupport=false">
            <img src="../../static/img/back.png" alt="">
          </li>
        </ul>

      </div>
    </div>
  </div>

</template>

<script>
    export default {
      name: "myfooter",
      data(){
        return {
          navActive:'',
          navChildActive:'',
          isLaw: false,
          isSupport:false,
          legalList:{}
        }
      },
      watch: {
        '$route'(to, from) {
          var linkOriginal=to.path;
          var link=to.path.split('/');
          if (link.length==3){
            this.navActive=linkOriginal;
            this.navChildActive='';
          }else {
            this.navActive='';
            this.navChildActive='/'+link[3];
            if (link[3]=='newsDetail'){
              this.navActive='/'+link[1]+'/'+link[2];
            }else if(link[3]=='realtyDetail'){
              this.navChildActive='/realty';
            }else if(link[3]=='subsidiaryDetail'){
              this.navChildActive='/subsidiary';
            }else if(link[3]=='reportDetail'){
              this.navChildActive='/report';
            }else if(link[3]=='headquarters'){
//            }else if(link[3]=='headquarters' || link[3]=='report' || link[3]=='reportDetail'){
              this.navActive='/'+link[1]+'/'+link[2];
            }
          }
        }
      },
      created(){
        var linkOriginal=this.$route.path;
        var link=this.$route.path.split('/');
        if (link.length==3){
          this.navActive=linkOriginal;
          this.navChildActive='';
        }else {
          this.navActive='';
          this.navChildActive='/'+link[3];
          if (link[3]=='newsDetail'){
            this.navActive='/'+link[1]+'/'+link[2];
          }else if(link[3]=='realtyDetail'){
            this.navChildActive='/realty';
          }else if(link[3]=='subsidiaryDetail'){
            this.navChildActive='/subsidiary';
          }else if(link[3]=='reportDetail'){
            this.navChildActive='/report';
          }else if(link[3]=='headquarters'){
//          }else if(link[3]=='headquarters' || link[3]=='report' || link[3]=='reportDetail'){
            this.navActive='/'+link[1]+'/'+link[2];
          }
        }

        this.$http.get(`/outer/legal/getLegal.do`).then((res)=>{//法律声明
          this.legalList=res.data
        })


      },

      methods:{
        navChange(txt,toLink,toLinkC){
          //二级导航
          if (toLinkC!=undefined){
            this.navActive='';
            this.navChildActive=toLinkC;
            this.$router.push({path: toLink+toLinkC});
            this.isSupport=false;

          }

          //一级导航
          if (txt=='nav' && toLink == '/main/index'){
            this.$router.push({path: toLink});
            this.navActive=toLink;
            this.navChildActive='';
          }else if (txt == 'nav' && toLink == '/main/newsNotice'){
            this.$router.push({path: toLink});
            this.navActive=toLink;
            this.navChildActive='';
          }else if(txt == 'nav' && toLink == '/main/contact'){
            this.$router.push({path: toLink+'/headquarters'});
            this.navActive=toLink;
            this.navChildActive='';
          }else {
            return;

          }
          this.isSupport=false;
        },
        goTopSearch(){
          this.$emit('goTopSearch')
        }
      }

    }
</script>

<style scoped lang="less">
  .el-footer{
    padding: 0!important;
  }
  .content{
    width:100%;
    height:1rem;
    background:rgba(245,245,245,1);
    ul{
      float: right;
      margin-right:calc(50% - 6rem);
      height:1rem;
      display: table;
      li{
        font-size: .14rem;
        display: table-cell;
        vertical-align: middle;
        float: left;
        border-right: 1px solid #666666;
        color: #666;
        margin-top:.5rem;
        padding: 0 .2rem;
        line-height:.14rem;
      }
      li:nth-child(3):hover{
        color: #f53a37;
        cursor: pointer;
      }
      li:last-child:hover{
        color: #f53a37;
      }
      li:last-child{
        cursor: pointer;
        border: 0;
      }
    }
  }

  .law{
    position: fixed;
    height:100%;
    width:0rem;
    z-index: 10;
    transition: width .3s ease;
    -webkit-transition: width .3s ease;/* Safari */
    background: rgba(0,0,0,.8);
    right:0;
    top:0;
    color: #fff;
    ul{
      width:100%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding:.5rem;
      li{
        text-align: justify;
        margin-bottom:.3rem;
        h3{
          font-size:.16rem;
          line-height:.6rem;
          font-weight:500;
        }
        p{
          font-size:.12rem;
          line-height:.24rem;
          font-weight:500;
        }
        img{
          width:.8rem;
          height:.8rem;
        }
      }
      li:last-child{
        position: absolute;
        top:calc(100vh - 1rem);
        cursor: pointer;
      }
    }
  }
  .wLaw{
    width:5rem;
  }
  .support{
    position: fixed;
    height:100%;
    width:0rem;
    z-index: 10;
    transition: width .3s ease;
    -webkit-transition: width .3s ease;/* Safari */
    background: rgba(0,0,0,.8);
    right:0;
    top:0;
    color: #fff;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    div{
      padding:.5rem;
    }
    h2{
      color: #F53A37;
      font-size:.4rem;
      line-height:.6rem;
      font-weight: 500;
    }
    p{
      font-size:.2rem;
    }

    ul{
      margin-top:.3rem;
      font-size:.16rem;
      line-height:.26rem;
      .active{
        color: red;
        list-style-color:#fff;
      }
      >li{
        cursor: pointer;
        margin-top:.1rem;
        list-style: inherit;
        img{
          width:.8rem;
          height:.8rem;
        }
        ol{
          overflow: hidden;
          li{
            float: left;
            margin-right:.15rem;
            i{
              padding-right:.1rem;
              display: inline-block;
              height:.14rem;
              border-right: 1px solid #fff;
              transform: translateY(.02rem);
            }
          }
          .activeChild{
            color: red;
          }
          li:last-child{
            i{
              display: none;
            }
          }
          li:nth-child(4){
            i{
              display: none;
            }
          }
        }
      }
      >li:last-child{
         position: absolute;
         top:calc(100vh - 1rem);
         cursor: pointer;
         list-style: none;
         margin-left:-.2rem;
       }
    }
  }

  .wSupport{
    width:5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue